import Page from "components/Page";
import React, { useEffect, useMemo, useState, Suspense } from "react";
import { withTranslation } from "react-i18next";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import Loader from "components/Loader";
import styles from "./Appointments.module.scss";
import { Link } from "react-router-dom/cjs/react-router-dom";
import alertImage from "../../../assets/images/alert-circle-black.svg";
import crossIcon from "../../../assets/images/mir_cross grey.svg";
import UpcomingTabs from "../Appointments/UpcomingTabs";
import RecallTabs from "../Appointments/RecallTab";
import Text from "components/Text";
import PastAppointmentTab from "./PastAppointmentTab";
import constants from "../../../constants";
import { encodeId, getStorage, setStorage } from "utils";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { useStaffByUserId } from "repositories/office-repository";

const PatientAppointments = ({ t, history }) => {
  const cachedActiveTab = getStorage(
    constants.patientScheduling.cache.eventlisting,
  );
  const officeState = getStorage("officeState");
  const isfromappointmentdashboard = getStorage(
    "is-from-appointment-dashboard",
  );
  let isFromStaffAdmin = getStorage(constants.notes.cache.isFromStaffAdmin);
  const yellowBarState = getStorage(constants.yellowBarState.active);
  const [activeTab, setActiveTab] = useState(
    cachedActiveTab?.activeTab ? cachedActiveTab.activeTab : 1,
  );
  const [officeId, setOfficeId] = useState({});
  const [showYellowBar, setShowYellowBar] = useState(() => {
    return yellowBarState != null ? yellowBarState : true;
  });

  const profile = useSelector((state) => state.userProfile.profile);
  const location = useLocation();
  const { state } = location;
  const appointmentRouteStateKey = useMemo(
    () =>
      [
        location.key,
        state?.activetabs,
        state?.officeId,
        JSON.stringify(state?.statusFilter ?? []),
      ].join("|"),
    [location.key, state?.activetabs, state?.officeId, state?.statusFilter],
  );
  const tabName = constants.patientAppointMentTab;

  const { data: staffDetail } = useStaffByUserId(
    officeState?.officeState?.officeId,
    profile?.id,
  );
  const goToPreviousScreen = () => {
    if (officeState?.officeState?.officeId) {
      if (isfromappointmentdashboard) {
        history.push(
          constants.routes.superAdmin.appointmentDashboard.replace(
            ":officeId",
            encodeId(officeState?.officeState?.officeId),
          ),
        );
        return;
      }
      if (profile?.role?.systemRole === constants.systemRoles.accountOwner) {
        history.push(
          constants.routes.accountOwner.officeOptions.replace(
            ":officeId",
            encodeId(officeState?.officeState?.officeId),
          ),
        );
      } else if (staffDetail?.isAdmin) {
        const route = isFromStaffAdmin
          ? constants.routes.staff.officeOptions
          : constants.routes.staff.officeAdmin;
        history.push(
          route.replace(
            ":officeId",
            encodeId(officeState?.officeState?.officeId),
          ),
        );
      } else {
        history.push(
          constants.routes.staff.officeOptions.replace(
            ":officeId",
            encodeId(officeState?.officeState?.officeId),
          ),
        );
      }
    } else {
      history.push("/");
    }
  };

  const handleClickYellowBar = () => {
    setStorage(constants.yellowBarState.active, false);
    setShowYellowBar(false);
  };
  const manageTab = (tab) => {
    window.scrollTo(0, 0);
    setActiveTab(tab);
    setStorage(constants.patientScheduling.cache.eventlisting, {
      activeTab: tab,
    });
  };

  useEffect(() => {
    if (state?.activetabs != null) {
      setActiveTab(state.activetabs);
    }
    if (state != null) {
      setStorage("officeState", {
        officeState: state,
      });
    }
    setStorage("isFromAppointmentDetail", {
      isFromAppointmentDetail: false,
    });
    setStorage("isFromManagePage", {
      isFromManagePage: false,
    });
    setStorage("createRecall", {
      createRecall: false,
    });
    setStorage("createPage", {
      isFromCreatePage: false,
    });
    setStorage("appointmentReminder", {
      appointmentReminder: false,
    });
    setStorage("isFromScheduler", false);
    setStorage("see-today-schedule", false);
    setStorage("isFromPatientAppointment", false);
    setStorage("isFromPatientChat", false);
    const storedOffice = getStorage("officeState");
    setOfficeId((prev) => {
      const next = storedOffice?.officeState ?? {};
      return prev?.officeId === next?.officeId ? prev : next;
    });
  }, [appointmentRouteStateKey]);

  return (
    <Page className="scheduler-page" onBack={goToPreviousScreen}>
      <div className={styles["first-row-top"]}>
        <div className={styles["first-row"]}>
          <div className={styles["first-row-text-part"]}>
            <p className="page-title mb-0">
              {t("patientAppointmentMembers.patientAppointments")}
            </p>
          </div>
          <div className={styles["btn-box"]}>
            {activeTab == tabName.upCommingAppointment && (
              <Link to="/see-today-schedule">
                <button className="button button-round button-border button-dark w-sm-100">
                  {t("patientAppointmentMembers.SeeTodayScheduleBtn")}
                </button>
              </Link>
            )}
            {!staffDetail?.isAdmin && (
              <Link
                to={
                  officeState?.officeState?.officeId
                    ? constants.routes.appointment.officeSelection.replace(
                        `:officeId`,
                        encodeId(officeState?.officeState?.officeId),
                      )
                    : constants.routes.appointment.manageSchedule
                }
              >
                <button className="button button-round button-border button-dark w-sm-100">
                  {t("patientAppointmentMembers.manageSchedule")}
                </button>
              </Link>
            )}
            <Link
              to={
                staffDetail?.isAdmin || staffDetail?.isReceptionist
                  ? constants.routes.appointment.doctorSelection
                      .replace(
                        ":officeId",
                        encodeId(officeState?.officeState?.officeId),
                      )
                      .replace("/:patientId?", "")
                  : officeState?.officeState?.officeId
                    ? constants.routes.appointment.patientNewAppointment
                        .replace(
                          ":officeId?",
                          encodeId(officeState?.officeState?.officeId),
                        )
                        .replace("/:doctorId?/:patientId?", "")
                    : constants.routes.appointment.patientNewAppointment.replace(
                        "/:officeId?/:doctorId?/:patientId?",
                        "",
                      )
              }
            >
              <button className="button button-round button-shadow w-sm-100">
                {t("patientAppointmentMembers.newAppointment")}
              </button>
            </Link>
          </div>
          {!officeState?.officeState?.officeId && showYellowBar && (
            <div className={styles["yellow-warning-box"]}>
              <img src={alertImage} alt="blackAlertImage" />
              <Text size="14px" weight="400" color="#2F3245">
                {t("patientAppointmentMembers.appointmentReminderPlanText")}
              </Text>
              <img
                src={crossIcon}
                alt="blackCrossImage"
                className="cursor-pointer"
                onClick={handleClickYellowBar}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles["appointment-tabs"] + " " + "form-wrapper"}>
        <Nav tabs className={styles["nav-tabs"]}>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                activeTab == tabName.upCommingAppointment
                  ? styles["active"]
                  : styles["not-active"]
              }
              onClick={() => manageTab(1)}
            >
              {t("patientAppointmentMembers.upcoming")}
            </NavLink>
          </NavItem>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                activeTab == tabName.recallAppointment
                  ? styles["active"]
                  : styles["not-active"]
              }
              onClick={() => manageTab(2)}
            >
              {t("patientAppointmentMembers.recall")}
            </NavLink>
          </NavItem>
          <NavItem className={styles["nav-items"]}>
            <NavLink
              className={
                activeTab == tabName.pastAppointment
                  ? styles["active"]
                  : styles["not-active"]
              }
              onClick={() => manageTab(3)}
            >
              {t("patientAppointmentMembers.past")}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <Suspense fallback={<Loader />}>
            <TabPane tabId={1}>
              {activeTab === tabName.upCommingAppointment && (
                <UpcomingTabs
                  state={state || officeState?.officeState}
                  manageTab={manageTab}
                />
              )}
            </TabPane>
            <TabPane tabId={2}>
              {activeTab === tabName.recallAppointment && (
                <RecallTabs state={state || officeState?.officeState} />
              )}
            </TabPane>
            <TabPane tabId={3}>
              {activeTab === tabName.pastAppointment && (
                <PastAppointmentTab state={state || officeState?.officeState} />
              )}
            </TabPane>
          </Suspense>
        </TabContent>
      </div>
    </Page>
  );
};
export default withTranslation()(PatientAppointments);
